// extracted by mini-css-extract-plugin
export default {"empty":"styles_empty__504P-","empty__img":"styles_empty__img__zf2jN","empty__ttl":"styles_empty__ttl__Nv5I4","empty__txt":"styles_empty__txt__EbYZ8"};